import { openDB } from 'idb';

const databaseName = 'aiq-webrtc-registry';
const storeName = 'webrtcEndpoints';
const indexNameByTabId = 'by_tabId';

export class WebRtcEndpointRegistry {
    #dbPromise;

    async add({ webrtcEndpointId, kurentoId, tabId }) {
        if (!webrtcEndpointId || !kurentoId || !tabId) return;

        try {
            const db = await this.#getDb();
            if (!db) return;

            await db.put(storeName, {
                webrtcEndpointId,
                kurentoId,
                tabId,
                createdAt: new Date().toISOString(),
            });
        } catch (err) {
            console.warn('[WebRtcEndpointRegistry] add failed', err);
        }
    }

    async remove(webrtcEndpointId) {
        if (!webrtcEndpointId) return;

        try {
            const db = await this.#getDb();
            if (!db) return;
            await db.delete(storeName, webrtcEndpointId);
        } catch (err) {
            console.warn('[WebRtcEndpointRegistry] remove failed', err);
        }
    }

    async getAll() {
        try {
            const db = await this.#getDb();
            if (!db) return [];
            return await db.getAll(storeName);
        } catch (err) {
            console.warn('[WebRtcEndpointRegistry] getAll failed', err);
            return [];
        }
    }

    async incrementReleaseErrorCount(webrtcEndpointId) {
        if (!webrtcEndpointId) return null;
        try {
            const db = await this.#getDb();
            if (!db) return null;
            const record = await db.get(storeName, webrtcEndpointId);
            if (!record) return null;
            const updated = { ...record, releaseErrorCount: (record.releaseErrorCount || 0) + 1 };
            await db.put(storeName, updated);
            return updated;
        } catch (err) {
            console.warn('[WebRtcEndpointRegistry] incrementReleaseErrorCount failed', err);
            return null;
        }
    }

    async getByTabId(tabId) {
        if (!tabId) return [];

        try {
            const db = await this.#getDb();
            if (!db) return [];
            return await db.getAllFromIndex(storeName, indexNameByTabId, tabId);
        } catch (err) {
            console.warn('[WebRtcEndpointRegistry] getByTabId failed', err);
            return [];
        }
    }

    async #getDb() {
        if (typeof indexedDB === 'undefined') return null;
        if (!this.#dbPromise) {
            this.#dbPromise = openDB(databaseName, 1, {
                upgrade(db, _oldVersion, _newVersion, transaction) {
                    if (!db.objectStoreNames.contains(storeName)) {
                        const objectStore = db.createObjectStore(storeName, { keyPath: 'webrtcEndpointId' });
                        objectStore.createIndex(indexNameByTabId, 'tabId', { unique: false });
                        return;
                    }

                    const objectStore = transaction.objectStore(storeName);
                    if (!objectStore.indexNames.contains(indexNameByTabId)) {
                        objectStore.createIndex(indexNameByTabId, 'tabId', { unique: false });
                    }
                },
            });
        }
        return this.#dbPromise;
    }
}

export const webRtcEndpointRegistry = new WebRtcEndpointRegistry();
